export enum IdFaseProcesso {
    Julgamento = 5,
}
